import React, { Component } from 'react';
import HomePageFooter from '../../../components/Home/HomePageFooter/HomePageFooter';

class HomePageFooterContainer extends Component {

  render() {
    return (
      <HomePageFooter />
    )
  }
}

export default (HomePageFooterContainer);



// WEBPACK FOOTER //
// ./src/containers/Home/HomePageFooter/HomePageFooter.js